import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class Space extends Component {
	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Space
					</div>
					<div>
						<DownloadFile title="Download Space Dump" url="dump/spaces"/>
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/space/update"/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SpaceOperations/Components/Space.js